<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Associar Documentos</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onAssociarDoc(1, null, false)" v-b-tooltip.hover.left="'Associar'" v-if="getPermission('associar.store')"><i class="ft-plus"></i></a></li>
                                    <li><a @click="onDesassociar(props.rowData, 4)" v-b-tooltip.hover.left="'Desassociar'" v-if="getPermission('associar.desassociar')"><i class="ft-minus-square"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                                api-url="/api/associar"
                                                :fields="fields"
                                                :css="css"
                                                :append-params="moreParams"
                                                track-by="pedunicar_id"
                                                pagination-path=""
                                                detail-row-component="associar-detalhes"
                                                @vuetable:cell-clicked="onDetail"
                                                @vuetable:load-error="onError"
                                                @vuetable:pagination-data="onPaginationData"
                                                @vuetable:loaded="onLoaded"
                                              >
                                              <template slot="pessoa" slot-scope="props">
                                                  {{ props.rowData.pedido.pessoa_tomador.pessoa_juridica.razao_social }}
                                              </template>

                                              <template slot="selecionado" slot-scope="props">
                                                  <b-form-checkbox buttons
                                                                   button-variant="secondary"
                                                                   v-model="props.rowData.selecionado"
                                                                   value="1"
                                                                   unchecked-value="2">
                                                  </b-form-checkbox>
                                              </template>

                                              <template slot="num_container" slot-scope="props">
                                                  <span v-if="props.rowData.carga_doc_unidade_carga.length>=1">
                                                      <b-form-input type="text"
                                                              placeholder="U"
                                                              v-model="props.rowData.carga_doc_unidade_carga[0].carga_doc.carga.num_container"
                                                              >
                                                       </b-form-input>
                                                   </span>

                                                   <span v-if="props.rowData.carga_doc_unidade_carga.length==0">
                                                       <b-form-input type="text"
                                                               placeholder="Unidade de transporte"
                                                               v-model="props.rowData.num_container"
                                                               >
                                                        </b-form-input>
                                                   </span>
                                              </template>

                                              <template slot="num_lacre" slot-scope="props">
                                                  <span v-if="props.rowData.carga_doc_unidade_carga.length>=1">
                                                      <b-form-input type="text"
                                                                  placeholder="Lacre"
                                                                  v-model="props.rowData.carga_doc_unidade_carga[0].carga_doc.carga.num_lacre"
                                                                  >
                                                      </b-form-input>
                                                  </span>

                                                  <span v-if="props.rowData.carga_doc_unidade_carga.length==0">
                                                      <b-form-input type="text"
                                                                  placeholder="Lacre"
                                                                  v-model="props.rowData.num_lacre"
                                                                  >
                                                      </b-form-input>
                                                  </span>
                                              </template>

                                              <template slot="obs" slot-scope="props">

                                                  <span v-if="props.rowData.carga_doc_unidade_carga.length>=1">
                                                      <b-form-input type="text"
                                                                  placeholder="Observação"
                                                                  v-model="props.rowData.carga_doc_unidade_carga[0].carga_doc.carga.obs"
                                                                  >
                                                      </b-form-input>
                                                  </span>

                                                  <span v-if="props.rowData.carga_doc_unidade_carga.length==0">
                                                      <b-form-input type="text"
                                                                  placeholder="Observação"
                                                                  v-model="props.rowData.pedido.obs_cte"
                                                                  >
                                                      </b-form-input>
                                                  </span>
                                              </template>

                                              <template slot="status_uc" slot-scope="props">
                                                    <span class="badge badge-info" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                                    <span class="badge badge-warning" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                                    <span class="badge badge-success" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}[ {{ props.rowData.carga_doc_unidade_carga.length }} ] </span>
                                                    <span class="badge badge-danger" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>
                                              </template>

                                              <template slot="actions" slot-scope="props">
                                                <div class="custom-actions">
                                                    <a @click="onAssociarDoc(props, props.rowIndex)" v-b-tooltip title="Associar DOC"  v-if="getPermission('associar.store')&&(props.rowData.status.valor!=2)"><i class="fa fa-list"></i></a>
                                                    <a @click="onDesassociar(props.rowData)" v-b-tooltip title="Desassociar"  v-if="getPermission('associar.desassociar')&&(props.rowData.carga_doc_unidade_carga.length>0)"><i class="fa fa-indent"></i></a>
                                                    <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes" v-if="(props.rowData.pedido_unidade_carga_trecho.length>0)"><i class="fa fa-plus"></i></a>
                                                  </button>
                                                </div>
                                              </template>
                                          </vuetable>
                                      </div>
                                      <div>
                                        <div class='col-md-12'>
                                              <div class="pull-left pagination-detail">
                                                <vuetable-pagination-info ref="paginationInfo"
                                                                          :css="css.pagination"
                                                                          info-class="pull-left"
                                                ></vuetable-pagination-info>
                                              </div>
                                              <div class="pull-right m-a-0">
                                                <vuetable-pagination ref="pagination"
                                                                     :css="css.pagination"
                                                                     @vuetable-pagination:change-page="onChangePage"
                                                ></vuetable-pagination>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <AssociarDocumentos
              v-on:reloadvue="onVuetableReload"
              ref="associardocumentos">
              </AssociarDocumentos>
    </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import AssociarFilterBar from './AssociarFilterBar'
import moment from 'moment'
import {VMoney} from 'v-money'
import accounting from 'accounting'
import AssociarDetalhes from './AssociarDetalhes'
import AssociarDocumentos from '../components/AssociarDocumentos'

Vue.component('associar-detalhes', AssociarDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': AssociarFilterBar,
        VMoney,
        AssociarDocumentos
    },
    data () {
        return {
            callbacksTour: {
                onNextStep: this.tourNextStepCallback,
                onStop: this.tourStop,
            },
            steps: [
            {
            target: ".step-inicio", // We're using document.querySelector() under the hood
            content: `Para gerar um CTE é muito fácil. <strong>Veja nossas dicas básicas</strong> para utilizar a tela e as funcionalidades disponíveis`,
            },
            {
            target: ".step-xml-nfe", // We're using document.querySelector() under the hood
            content: `Nesta opção você pode importar o XML da NFe que seu cliente lhe enviou. Ao importar a NFe ela será apresentada na listagem abaixo`,
            params: {
                placement: "top",
            },
            },
            {
            target: ".step-xml-cte", // We're using document.querySelector() under the hood
            content: `Você pode importar xml de CTE também, para gerar seu CTE de redespacho ou redespacho intermediário com mais facilidade`,
            params: {
                placement: "top",
            },
            },
            {
            target: ".step-gerar",
            content:
                "Para gerar um CTE, você deve clicar no + ao lado! Para facilitar, você pode selecionar os documentos na listagem abaixo ( NFe importadas ) que irão estar presentes no CTE e clicar no mais, ou, pode clicar diretamente no botão e adicionar os documentos na tela que irá abrir",
            params: {
                placement: "left",
            },
            },
            {
            target: ".step-ocultar",
            content:
                "Você pode ocultar um documento da listagem, de forma a não visualizar. Basta selecionar o checkbox no lado esquerdo, e, ocultar em lote. Caso seja necessário reapresentar a NF, você pode filtrar os documentos ocultados.",
            params: {
                placement: "top",
            },
            },
            {
            target: ".step-filtrar",
            content:
                "Para filtrar um documento específico, localizar documentos já utilizados, você encontra diversos filtros de documentos importados",
            params: {
                placement: "top",
            },
            },
        ],
          date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          showPopover: false,
          loadingAddDoc: false,
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          form: new Form({ pedunicar_id: '',
                           num_container: '',
                           num_lacre: '',
                           obs: '',
                           docfis: [],
                           docfisDig: [],
                           doctransp: [],
                           doctranspDig: []
                       }),
          fields: [
            {
              name: '__slot:selecionado',
              title: '',
            },
            {
              name: '__slot:pessoa',
              title: 'Tomador'
            },
          {
            name: 'num_uc',
            title: 'N° UC',
            sortField: 'num_uc'
          },
          {
            name: '__slot:num_container',
            title: 'Unidade de transporte',
          },
          {
            name: '__slot:num_lacre',
            title: 'Lacre',
          },
          {
            name: '__slot:obs',
            title: 'Obs',
          },
          {
            name: 'vlr_total_receita',
            title: 'Valor Pedido',
            callback: 'formatNumber'
          },
          {
            name: 'vlr_total_advalorem',
            title: 'Valor Advalorem',
            callback: 'formatNumber'
          },
          {
            name: 'vlr_total',
            title: 'Valor Total',
            callback: 'formatNumber'
          },
          {
            name: '__slot:status_uc',
            title: 'Status',
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }],
       css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
         },
       moreParams: {}
       }
    },
    directives: {
       money: VMoney,
       qtd: VMoney,
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.$events.$on('filter-reload', e => this.onVuetableReload());
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
              'num_pedido': data_filter.num_pedido,
              'num_uc': data_filter.num_uc,
              'tom_cnpj': data_filter.tom_cnpj,
              'for_cnpj': data_filter.for_cnpj,
              'dt_inicio': data_filter.dt_inicio,
              'dt_fim': data_filter.dt_fim,
              'status': data_filter.status.value
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onVuetableReload() {
            this.moreParams = {};
            Vue.nextTick( () => this.$refs.vuetable.refresh());
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh());
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.pedunicar_id);
        },
        onAssociarDoc(data)     {
            this.$refs.associardocumentos.onAssociarDoc(data); // PedidoUnidadeCarga
        },
        onDesassociar (data, status) {

            let form = this.form;

            var vm = this;
            var pedunicar_id = data.pedunicar_id;
            const onConfirmUnitWrapper = () => {
                confirmDesassociarFn(vm, pedunicar_id);
            }

            let confirmDesassociarFn = function(vm, pedunicar_id) {
                vm.form.pedunicar_id = pedunicar_id;
                vm.form.post('/api/associar/desassociar').then(response =>
                {
                    new ReturnApi(response, vm)
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, vm)
                });
            }

            let obj = {
                title: 'Você deseja Desassociar todas notas da UC '+data.num_uc+' ?',
                message: 'Esta ação é irreversível',
                customConfirmBtnText: 'Sim',
                customCloseBtnText: 'Não',
                type: 'info',
                useConfirmBtn: true,
                onConfirm: onConfirmUnitWrapper
            }

            this.$Simplert.open(obj);
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
            var cnpj_formatado
            var pad = "00000000";
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
            return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
        },
        formatTypedDate: function (dateString)
        {
           let result = dateString.split('/')
           return result[2] + '-' + result[1] + '-' + result[0] + 'T00:00:00-03:00'
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
